export default __webpack_public_path__ + "static/nu-80ae88a6dbbe77eca96d9dcc66140b12.svg";